import styled from 'styled-components';

const ButtonBase = styled.button(
  props => `
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    border:none;
    background-color: ${props.theme.colors.goBrandOrange.base};
    color: ${props.theme.colors.goWhite.base};
    font-family: ${props.theme.font.fontFamily};
    font-weight: bold;
    text-transform: uppercase;
    border-radius: ${props.theme.misc.borderRadius.xxxlarge};
    font-size:${props.theme.font.custom(16)};
    &:focus{
      box-shadow: none;
      outline-offset: 0;
      outline: 0;
    }
  `,
);

export const QuickBookBtn = styled(ButtonBase)(
  props => `
    display:flex;
    padding: ${props.theme.spacing.custom(12)} ${props.theme.spacing.custom(8)};
    height:${props.height || '4.2rem'};
    font-family: inherit;
    font-size: ${props.theme.font.custom(14)};
    text-transform: none;
    width:${props.width || '65%'};
    border-radius: ${props.borderRadius || ''};
  `,
);

export const BookNowCTA = styled.span(
  props => `
    color: ${props.theme.colors.goBrandBlue.base};
    font-size: ${props.theme.font.custom(16)};
    font-weight: bold;
    cursor:pointer;
      `,
);
